import { render } from "./DashboardIndex.vue?vue&type=template&id=69701888"
import script from "./DashboardIndex.vue?vue&type=script&lang=js"
export * from "./DashboardIndex.vue?vue&type=script&lang=js"
script.render = render

export default script